import { AxiosUpdateTuple, usePutAxiosHook } from '../../AxiosPutHook';

const URL = '/api/clients/update';

export const useUpdateClient = (): AxiosUpdateTuple => {
  const [callBack, { data, loading, called, error }] = usePutAxiosHook(URL);

  return [callBack, { data, loading, called, error }];
};
